<template>
  <div id="footer">
    <div id="rename-me-06" v-if="!isFailedPage && !isRejectedPage && !isPageNotFound && !isCurrencyCrypto">
      <div v-if="!hasSubscription">
        <img src="@/assets/images/processing-security-dss.svg" alt="Payment Card Industry Data Security Standard">
        <img src="@/assets/images/processing-security-visa.svg" alt="Verified by Visa">
        <img src="@/assets/images/processing-security-mir.svg" :alt="$t('mir.secure')">
        <img src="@/assets/images/processing-security-mastercard.svg" alt="Security with Mastercard SecureCode">
      </div>
    </div>

    <!-- МОДУЛЬ #RENAME-ME-07: Блок для отображения прочей информации  -->
    <!-- МОДИФИКАТОРЫ: -->
    <!-- <div id="rename-me-07">
      <p>Платёжный сервис Capusta.space ООО «Пэйтерра»</p>
    </div> -->

    <!-- МОДУЛЬ #RENAME-ME-08: Блок для отображения помощи -->
    <!-- МОДИФИКАТОРЫ: -->
    <div id="rename-me-08" v-if="isResultPage && !isFailedPage && !isRejectedPage && !isPageNotFound">
      <p>{{ $t('contact.the.recipient') }} —
        <a v-if="PROJECT.email" :href="`mailto:${PROJECT.email}`"> {{ PROJECT.email }} </a>
        <span v-else>{{ PROJECT.project_name }}</span>
      </p>
    </div>

    <!-- МОДУЛЬ #RENAME-ME-07: Блок для отображения прочей информации  -->
    <!-- МОДИФИКАТОРЫ: -->
    <!-- <div id="rename-me-07" v-if="!isFailedPage && !isRejectedPage">
      <p>Сервис переводов Capusta.Space <br> ООО «Капуста Спэйс»</p>
    </div> -->

    <!-- МОДУЛЬ #RENAME-ME-10: Блок для отображения прочей информации  -->
    <!-- МОДИФИКАТОРЫ: -->
    <div id="rename-me-10" v-if="!isFailedPage && !isRejectedPage && !isPageNotFound">
      <div>
        <p>
          <template v-if="getCopyright">
            &copy; {{ $t(getCopyright) }}
            <br>
          </template>
          {{ $t(getCompanyName) }}
        </p>
        <img :src="getLogoLink" alt="" />
      </div>
    </div>

    <!-- МОДУЛЬ #RENAME-ME-11: Блок для отображения логотипа -->
    <!-- МОДИФИКАТОРЫ: -->
    <div
      v-if="isFailedPage || isRejectedPage || isPageNotFound"
      id="rename-me-11"
      class="align-bottom"
    >
      <div>
        <img :src="getLogoLink" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'FooterSection',
  props: {
    hasSubscription: Boolean,
  },
  computed: {
    isResultPage() {
      return this.$route.name === 'paid.payment' || this.$route.name === 'failed.payment';
    },
    isPageNotFound() {
      return this.$route.name === 'service.error';
    },
    isFailedPage() {
      return this.$route.name === 'failed.payment';
    },
    isRejectedPage() {
      return this.$route.name === 'rejected.payment';
    },
    ...mapState(['PROJECT', 'TRANSACTION']),
    ...mapGetters([
      'isPrimaryUzbekistanProvider',
      'isPrimaryRussianProvider',
      'getCompanyName',
      'getCopyright',
      'getLogoLink',
      'isCurrencyCrypto',
    ]),
  },
};
</script>
